import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter
} from '@angular/core';
import { Translate } from "../../services";
import { Observable } from "rxjs/Observable";

@Component({
  selector: 'cs-help',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `    
    <div class="cs-help">
      <div class="cs-help__content">
        <h1>Help</h1>
        
        <p class="alert">
          <strong>{{ (translations$ | async)['help#attenzione'] }}</strong><br>
          {{ (translations$ | async)['help#box_orange_line_0'] }}
          <strong>{{ (translations$ | async)['help#box_orange_line_1'] }}</strong>
          {{ (translations$ | async)['help#box_orange_line_2'] }}
        </p>
        
        <p>
          {{ (translations$ | async)['help#box_parag_0'] }}
        </p>
        
        <p>
          {{ (translations$ | async)['help#box_parag_1_line_0'] }}
          <strong>{{ (translations$ | async)['help#box_parag_1_line_1'] }}</strong>
          {{ (translations$ | async)['help#box_parag_1_line_2'] }}
        </p>
        
        <p>
          {{ (translations$ | async)['help#box_parag_2'] }}
        </p>
        
        <!-- <p>
          Per ogni sezione è assegnato 1 punto alla risposta corretta, 
          0 punti alla risposta non data e -0,25 punti alla risposta errata.
        </p> -->
        
        <h2>{{ (translations$ | async)['help#sezioni'] }}</h2>
        
        <table>
          <tr>
            <td>
              <img 
                src="assets/img/section-current.png" 
                width="110" 
                height="35"><br>
              {{ (translations$ | async)['help#image_0'] }}
            </td>
            <td>
              <img 
                src="assets/img/section-enabled.png" 
                width="110" 
                height="35"><br>
              {{ (translations$ | async)['help#image_1'] }}
            </td>
            <td>
              <img 
                src="assets/img/section-disabled.png" 
                width="110" 
                height="35"><br>
              {{ (translations$ | async)['help#image_2'] }}
            </td>
          </tr>
        </table>
        
        <h2>{{ (translations$ | async)['help#quesiti'] }}</h2>
        
        <table>
          <tr>
            <td>
              <img 
                src="assets/img/quesito-current.png" 
                width="33" 
                height="37"><br>
              {{ (translations$ | async)['help#image_3'] }}
            </td>
            <td>
              <img 
                src="assets/img/quesito-done.png" 
                width="33" 
                height="37"><br>
              {{ (translations$ | async)['help#image_4'] }}
            </td>
            <td>
              <img 
                src="assets/img/quesito-next.png" 
                width="33" 
                height="37"><br>
              {{ (translations$ | async)['help#image_5'] }}
            </td>
            <td>
              <img 
                src="assets/img/quesito-text.png" 
                width="34" 
                height="43"><br>
              {{ (translations$ | async)['help#image_6'] }}
            </td>
            <td>
              <img 
                src="assets/img/quesito-nav.png" 
                width="88" 
                height="43"><br>
              {{ (translations$ | async)['help#image_7'] }}
            </td>
          </tr>
        </table>
        
        <h2>{{ (translations$ | async)['help#altri_strumenti'] }}</h2>
        
        <table>
          <tr>
            <td width="98">
              <img *ngIf="lang == 'it'" src="assets/img/finish_it.png" width="98" height="51">
              <img *ngIf="lang == 'en'" src="assets/img/finish_en.png" width="98" height="51">
            </td>
            <td>
              {{ (translations$ | async)['help#altri_strumenti_button_0'] }}
            </td>
            <td width="61">
              <img src="assets/img/help.png" width="61" height="35">
            </td>
            <td>
              {{ (translations$ | async)['help#altri_strumenti_button_1'] }} <strong>Help</strong>
            </td>
          </tr>
        </table>

        <h2>Zoom</h2>
        <p>
          {{ (translations$ | async)['help#box_parag_4'] }}
          <br>
        </p>
        
        <h2>Timer</h2>
        
        <table>
          <tr>
            <td width="180">
              <img *ngIf="lang == 'it'" src="assets/img/timer_it.png" width="180" height="22">
              <img *ngIf="lang == 'en'" src="assets/img/timer_en.png" width="180" height="22">
            </td>
            <td>
              {{ (translations$ | async)['help#timer_image'] }}
            </td>
          </tr>
        </table>
        
        <h2>Audio</h2>
        
        <table>
          <tr>
            <td width="180">
              <img src="assets/img/audio-player.png" width="500" height="40">
            </td>
            <td>
              {{ (translations$ | async)['help#audio_player'] }}
            </td>
          </tr>
        </table>
      </div>
      <button 
        class="cs-help__close-button ion-close-round"
        (click)="closeHelp.emit()"></button>
    </div>
  `
})

export class CsHelpComponent {
  @Output() closeHelp = new EventEmitter<Object>();

  translations$: Observable<any> = this.translate.getTranslations$();
  lang;

  constructor(
    private translate: Translate,
  ) {
    this.lang = this.translate.getCurrentLanguage();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-help/cs-help.component.ts